import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
declare const window: any;
@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toastRef: any;

  title: any = null;
  constructor(private readonly toastr: ToastrService) {
    window.toastService = this;
  }

  /**
   * @description show success toaster
   * @param msg toast message
   */
  showSuccess(msg: string) {
    this.toastRef = this.toastr.success(msg, this.title, {
      tapToDismiss: true,
      closeButton: true,
      positionClass: 'toast-top-right',
    });
  }

  /**
   * @description show error toaster
   * @param msg toast message
   */
  showError(msg: string) {
    this.toastRef = this.toastr.error(msg, this.title, {
      tapToDismiss: true,
      closeButton: true,
      positionClass: 'toast-top-right',
    });
  }

  removeToast = () => {
    this.toastr.clear(this.toastRef.ToastId);
  };
}
